
function hasPermissions(permission,key) {
  if(key === "") return true;
  if(permission.indexOf('*') !== -1) return true;
  return permission.indexOf(key) !== -1
}

export default function (menu,permission) {
  let newMenu = {};
  for (let k in menu) {
    let menuItem = menu[k];
    if (!menuItem.hasOwnProperty('permissionsKey')) {continue}
    if (!hasPermissions(permission, menuItem.permissionsKey)) {continue}
    newMenu[k] = menu[k];
    const newMenuKey = newMenu[k].hasOwnProperty('children') && Object.keys(newMenu[k].children) || [];
    if (!newMenuKey.length) {continue}//如果没有子元素或者子元素不是数组
    for (let key of newMenuKey){
      if(!newMenu[k].children[key].hasOwnProperty('permissionsKey')){delete newMenu[k].children[key];continue}
      if(!hasPermissions(permission,newMenu[k].children[key].permissionsKey)){
        delete newMenu[k].children[key];
      }
    }
  }
  return newMenu;
}
